import { api } from '.'

export const authApi = api.injectEndpoints({
  endpoints: build => ({
    auth: build.mutation({
      query: ({ code, mobile_phone }) => ({
        url: `/mega_cards/apply-auth/`,
        method: 'POST',
        body: { mobile_phone, code }
      })
    }),
    sendOtp: build.mutation({
      query: ({ code, mobile_phone }) => ({
        url: `/mega_cards/send-otp/`,
        method: 'POST',
        body: { mobile_phone, code }
      })
    })
  })
})

export const { useAuthMutation, useSendOtpMutation } = authApi
